export default {
  title: '导出&下载历史',
  desc: '统一查看项目的导出、下载及推送历史。',
  exportExc: '导出Excel',
  tab1: '可玩项目',
  tab2: '视频项目',
  tab3: '录屏项目',
  tab4: 'AI项目',
  record: {
    state: {
      success: '导出成功',
      exporting: '导出中',
      fail: '导出失败',
    },
    select: {
      name: '作品名称',
      projectId: '项目ID',
      projectName: '项目名称',
      versionId: '版本ID',
      versionName: '版本名称',
    },
    table: {
      name: '作品名称',
      state: '导出状态',
      operation: {
        name: '操作',
        again: '重新导出',
        look: '预览',
        down: '下载',
      },
      exportTime: '导出时间',
      updateTime: '更新时间',
      nameId: '项目名称及ID',
      versionId: '版本名称及ID',
      material: {
        id: '素材ID',
        unsupportAnalyze: '当前素材暂不支持分析功能',
        analyze: '素材分析',
      },
    },
  },
  video: {
    state: {
      success: '导出成功',
      exporting: '导出中',
      fail: '导出失败',
      waiting: '待排队',
      queuing: '排队中',
      completed: '已完成',
      partSuccesss: '部分成功',
    },
    select: {
      name: '作品名称',
      id: '项目ID',
      projectName: '产品名称',
      exportId: '导出任务ID',
      nameId: '作品ID',
    },
    table: {
      name: '作品名称及ID',
      stats: '导出状态',
      operations: '操作',
      ProjectId: '项目名称及ID',
      size: '尺寸',
      resolution: '分辨率',
      fileSize: '大小',
      number: '推送成功次数',
      exportTime: '导出时间',
      operation: {
        lookProject: '预览作品',
        downProject: '下载作品',
        Mintegral: '推送至Mintegral',
      },
      pushId: '推送记录ID',
      exportStatus: '任务状态',
      pushVideoCounts: '已推送视频数',
      pushCounts: '推送数',
      exportCount: '导出数',
      pushAgain: '重新推送',
      batchDownload: '批量下载',
      downProject: '下载作品',
      cancelExport: '取消导出',
      cancelMainTitle: '确定取消导出排队中的作品吗？',
      cancelSubTitle: '确认取消导出后，作品将无法重新导出。',
      againMainTitle: '确定重新导出失败的作品吗？',
      againSubTitle: '确认重新导出后，作品将重新加入导出队列。',
      verificationName:
        '部分作品名不符合要求，仅能包含数字、字母、下划线，请批量修改名称后重新推送。',
      batchRename: '批量命名',
      example: '示例',
      newProject: '新建项目',
    },
    push: {
      channel: '推送渠道',
      name: '推送作品名称',
      username: '仅限推送账号',
    },
    history: {
      table: {
        name: '作品名称',
        state: '推送状态',
        operations: '操作',
        channel: '投放渠道',
        username: '推送账号',
        data: '推送日期',
      },
      push: {
        state: {
          success: '推送成功',
          feld: '推送失败',
          ing: '推送中',
        },
        Mintegral: '推送至Mintegral',
      },
    },
    table1: '导出任务',
    table2: '作品',
    table3: '推送记录',
    pushCountTips: '推送成功数 / 推送作品总数',
    pushTime: '推送时间',
  },
  ai: {
    history: {
      table: {
        taskNameId: '任务名称及ID',
        status: '状态',
        operations: '操作',
        fileCount: '生成数',
        languages: '语言',
        duration: '时长',
        workNameId: '作品名称及ID',
        download: '下载',
        create: '新建成视频项目',
        taskName: '任务名称',
        taskId: '任务ID',
        workName: '作品名称',
        workId: '作品ID',
      },
    },
    table: {
      status: {
        pending: '生成中',
        success: '生成成功',
        failed: '生成失败',
      },
    },
  },
}
